module.exports = __webpack_public_path__ + "static/img/bj.fb0c464.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bj.jpeg
// module id = GZOM
// module chunks = 1